import {useCurrentFlowId} from "@page-containers/booking/utils/bookingQuery";
import {useCallback} from "react";

import {GetSchedulingRedirectUrlParams} from "./components/_common/types";
import {memoizedGetSchedulingRedirectUrl} from "./utils/getRedirectUrl";

export const useGetSchedulingRedirectUrl = (): ((
  args: GetSchedulingRedirectUrlParams,
) => string) => {
  const flowId = useCurrentFlowId();

  return useCallback(
    args =>
      memoizedGetSchedulingRedirectUrl({
        ...args,
        flowId: flowId || args.flowId,
      }),
    [flowId],
  );
};
